import catalouge01 from './image/catalouge-01.jpg'
import catalouge02 from './image/catalouge-02.jpg'
import catalouge03 from './image/catalouge-03.jpg'
import catalouge04 from './image/catalouge-04.jpg'
import catalouge05 from './image/catalouge-05.jpg'
import catalouge06 from './image/catalouge-06.jpg'
import catalouge07 from './image/catalouge-07.jpg'
import catalouge08 from './image/catalouge-08.jpg'
import catalouge09 from './image/catalouge-09.jpg'
import catalouge10 from './image/catalouge-10.jpg'
import catalouge11 from './image/catalouge-11.jpg'
import catalouge12 from './image/catalouge-12.jpg'
import catalouge13 from './image/catalouge-13.jpg'
import catalouge14 from './image/catalouge-14.jpg'
import catalouge15 from './image/catalouge-15.jpg'
import catalouge16 from './image/catalouge-16.jpg'
import catalouge17 from './image/catalouge-17.jpg'
import catalouge18 from './image/catalouge-18.jpg'
import catalouge19 from './image/catalouge-19.jpg'
import catalouge20 from './image/catalouge-20.jpg'
import catalouge21 from './image/catalouge-21.jpg'
import catalouge22 from './image/catalouge-22.jpg'
import catalouge23 from './image/catalouge-23.jpg'
import catalouge24 from './image/catalouge-24.jpg'
import catalouge25 from './image/catalouge-25.jpg'
import catalouge26 from './image/catalouge-26.jpg'
import catalouge27 from './image/catalouge-27.jpg'
import catalouge28 from './image/catalouge-28.jpg'
import catalouge29 from './image/catalouge-29.jpg'
import catalouge30 from './image/catalouge-30.jpg'
import catalouge31 from './image/catalouge-31.jpg'
import catalouge32 from './image/catalouge-32.jpg'
import catalouge33 from './image/catalouge-33.jpg'
import catalouge34 from './image/catalouge-34.jpg'
import catalouge35 from './image/catalouge-35.jpg'
import catalouge36 from './image/catalouge-36.jpg'
import catalouge37 from './image/catalouge-37.jpg'
import catalouge38 from './image/catalouge-38.jpg'
import catalouge39 from './image/catalouge-39.jpg'
import catalouge40 from './image/catalouge-40.jpg'
import catalouge41 from './image/catalouge-41.jpg'
import catalouge42 from './image/catalouge-42.jpg'
import catalouge43 from './image/catalouge-43.jpg'
import catalouge44 from './image/catalouge-44.jpg'
// import catalouge45 from './image/catalouge-45.jpg'
// import catalouge46 from './image/catalouge-46.jpg'
// import catalouge47 from './image/catalouge-47.jpg'


export const data=[
    {page:1,img:catalouge01},
    {page:2,img:catalouge02},
    {page:3,img:catalouge03},
    {page:4,img:catalouge04},
    {page:5,img:catalouge05},
    {page:6,img:catalouge06},
    {page:7,img:catalouge07},
    {page:8,img:catalouge08},
    {page:9,img:catalouge09},
    {page:10,img:catalouge10},
    {page:11,img:catalouge11},
    {page:12,img:catalouge12},
    {page:13,img:catalouge13},
    {page:14,img:catalouge14},
    {page:15,img:catalouge15},
    {page:16,img:catalouge16},
    {page:17,img:catalouge17},
    {page:18,img:catalouge18},
    {page:19,img:catalouge19},
    {page:20,img:catalouge20},
    {page:21,img:catalouge21},
    {page:22,img:catalouge22},
    {page:23,img:catalouge23},
    {page:24,img:catalouge24},
    {page:25,img:catalouge25},
    {page:26,img:catalouge26},
    {page:27,img:catalouge27},
    {page:28,img:catalouge28},
    {page:29,img:catalouge29},
    {page:30,img:catalouge30},
    {page:31,img:catalouge31},
    {page:32,img:catalouge32},
    {page:33,img:catalouge33},
    {page:34,img:catalouge34},
    {page:35,img:catalouge35},
    {page:36,img:catalouge36},
    {page:37,img:catalouge37},
    {page:38,img:catalouge38},
    {page:39,img:catalouge39},
    {page:40,img:catalouge40},
    {page:41,img:catalouge41},
    {page:42,img:catalouge42},
    {page:43,img:catalouge43},
    {page:44,img:catalouge44},
    // {page:45,img:catalouge45},
    // {page:46,img:catalouge46},
    // {page:47,img:catalouge47},
    
]
export const toc=[
    {
        text:'Cover',
        page:0
    },
    {
        text:'Foreword',
        page:1
    },
    {
        text:'Pathway Public Workshop',
        page:6
    },
    {
        text:'Calendar',
        page:14
    },
    {
        text:'Pathway HR Academy',
        page:27
    },
    {
        text:'Event Management',
        page:31
    },
    {
        text:'Coming Soon Event',
        page:37
    },
]
